import roleParents from './role-parents';

const roleChildren = {};

Object.keys(roleParents).forEach(parent => {
  roleChildren[roleParents[parent]] = parent;
});

export default roleChildren;
